<template>
  <div class="bg-indigo-50/50 py-16">
    <div class="mx-auto max-w-7xl px-6 lg:px-8 place-items-center">
      <div class="sm:text-center">
        <p class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          <span v-if="agency">The perfect match for your clients</span>
          <span v-else>How Bulba works?</span>
        </p>
        <p class="mx-auto mt-6 max-w-2xl text-lg leading-8 text-gray-600">
          Get collaboration requests from influencers of your preference, tailored to your availability, for as many
          locations and brands as you want
        </p>
      </div>
      <div class="flex flex-col md:flex-row mt-20 md:items-center">
        <div class="flex-grow space-y-12 mx-14">
          <div v-for="(step, index) in steps" :key="step.title">
            <p class="text-3xl font-bold relative">
              <span class="block absolute -left-14 bg-indigo-100 text-indigo-700/60 text-2xl w-9 h-9 rounded-full text-center">{{index + 1}}</span>
              {{step.title}}
            </p>
            <p class="max-w-lg mt-3 leading-6 text-lg text-gray-600">
              {{step.subtitle}}
            </p>
          </div>

          <div class="mt-12 flex items-center justify-start gap-x-6">
            <RouterLink
              to="/business/signup"
              class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >Start your free trial</RouterLink
            >
            <div class="text-sm font-semibold leading-6 text-gray-900">
              <a href="https://calendly.com/bulba/30-min-call" target="_blank">
                Book a demo <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </div>
        <div class="flex flex-col space-y-8 items-center justify-center mt-20 md:mt-0">
          <img class="rounded-lg shadow-[0_6px_20px_#00000043] max-w-xl w-full block object-contain" :src="howItWorks2"/>
          <img class="rounded-lg shadow-[0_6px_20px_#00000043] max-w-xl w-full block object-contain" :src="howItWorks"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import howItWorks from '@/assets/img/how_it_works.jpg'
import howItWorks2 from '@/assets/img/how_it_works_2.jpg'

const props = withDefaults(defineProps<{agency: boolean}>(), {agency: false})

const steps = ref<{title: string, subtitle: string}[]>([
  {
    title: "Create your campaign",
    subtitle: `Add your offer, content requirements, availability days/times, and requirements of eligibility to your
               campaign. Matching influencers will then be able to see your campaign from the creator app.`
  },
  {
    title: "Influencers request to collaborate",
    subtitle: `Your business will attract influencers that meet your campaign requirements. Once published, you will start
               receiving booking requests.`
  },
  {
    title: "Schedule collaboration visits",
    subtitle: `Answer collaboration booking requests by either accepting, requesting reschedule, or declining the influencer.`
  },
])
</script>

<style scoped>
</style>
